import { render, staticRenderFns } from "./OfficeRevenueHeadReport.vue?vue&type=template&id=4ab5491f&"
import script from "./OfficeRevenueHeadReport.vue?vue&type=script&lang=js&"
export * from "./OfficeRevenueHeadReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports